import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "marketing-banner",
  class: "flex h-full justify-center items-center gap-16 bg-transparent pb-32"
}
const _hoisted_2 = {
  id: "marketing-phrases",
  class: "h-[100vh] w-full bg-white flex flex-col justify-center items-center py-12 gap-6 max-sm:gap-12 max-md:p-[12.5vw] overflow-y-hidden overflow-x-hidden"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", { class: "text-[4rem]" }, "Converza é Conversão")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "max-sm:hidden text-[1.5rem]" }, "Você configura uma vez, seus clientes conectam, a gente converte."),
  /*#__PURE__*/_createElementVNode("p", { class: "sm:hidden text-[1.5rem]" }, "Configure uma vez, a gente converte.")
], -1)
const _hoisted_5 = { class: "p-6 flex sm:gap-16 max-sm:gap-2" }
const _hoisted_6 = {
  id: "marketing-how-it-works",
  class: "h-[100vh] w-full bg-blue-200 flex flex-col justify-center items-center py-12 gap-6 max-sm:gap-12 max-md:px-[12.5vw] overflow-y-hidden overflow-x-hidden"
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"flex-1 max-h-[50%] box-border\"><strong class=\"max-sm:text-[3rem] sm:text-[4rem] box-border\">Automatize seu atendimento</strong></div><div class=\"text-[1.5rem] max-h-[25%] box-border flex-1 line-clamp-3 flex flex-col\"><p class=\"max-md:hidden flex-1 box-border\">A conversão de leads começa com um bom suporte.</p><p class=\"max-md:text-[1rem] flex-1 box-border\">Minimize o trabalho difícil, deixe o Converza responder!</p><p class=\"max-md:hidden flex-1 box-border\">e só responda quem realmente <strong>converte.</strong></p></div>", 2)
const _hoisted_9 = { class: "flex-1 p-6 flex gap-16 max-h-[25%]" }

import Button from '@/components/ui/button/Button.vue';
import { get, set } from '@vueuse/core';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LandingPageHomeView',
  setup(__props) {

const scrollToId = (id: string) => {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
};

const sections = [
  'big-main',
  'marketing-phrases',
  'marketing-how-it-works'
];

let currentIndexRef = ref(0);
let blockWheel = ref(false);

const handleWheel = (event: WheelEvent) => {
  event.preventDefault();

  if (get(blockWheel)) {
    return;
  }
  set(blockWheel, true);

  const isScrollBelow = event.deltaY > 0;

  let currentIndex = get(currentIndexRef);
  currentIndex = isScrollBelow ? Math.min(sections.length - 1, currentIndex + 1) : Math.max(0, currentIndex - 1);

  scrollToId(sections[currentIndex]);
  set(currentIndexRef, currentIndex);

  setTimeout(() => {
    set(blockWheel, false);
  }, 500);
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", {
    class: "flex-1 overflow-x-hidden",
    onWheel: handleWheel
  }, [
    _createElementVNode("section", {
      class: _normalizeClass(["max-sm:hidden grow m-auto w-full h-[75vh]", `bg-[linear-gradient(to_bottom,rgba(229,241,255,1.0),rgba(255,255,255,0.9)),url('/public/img/bg_login_reduce.jpg')]`])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Button, {
          class: "text-xl",
          onClick: _cache[0] || (_cache[0] = () => scrollToId('marketing-phrases')),
          variant: "outline"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Conhecer o Converza ")
          ]),
          _: 1
        }),
        _createVNode(Button, { class: "rounded-full text-lg" }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: "/login",
              class: "text-xl"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Quero Assinar")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(Button, {
          class: "text-xl",
          onClick: _cache[1] || (_cache[1] = () => scrollToId('marketing-how-it-works')),
          variant: "outline"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Como funciona? ")
          ]),
          _: 1
        }),
        _createVNode(Button, { class: "rounded-full text-lg" }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: "/login",
              class: "text-xl"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Quero Assinar")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_9, [
        _createVNode(Button, { class: "rounded-full text-lg" }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: "/login",
              class: "text-xl"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Quero Assinar")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ], 32))
}
}

})